// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e9AJf","content":"styles_content__IQUCu","row":"styles_row__1UAOM","footer":"styles_footer__3toaY","phraseLength":"styles_phraseLength__1iv37"};